<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
.posiTop {
  position: fixed;
  top: 5%;
  right: 5%;
}
.posiBot {
  position: fixed;
  bottom: 5%;
  right: 5%;
}
.secondBtn {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue